import { FC, useState } from 'react';
import { Grid, GridSortChangeEvent, ISortDescriptor } from 'lca-common-ui-components';
import { useUserSettings } from 'src/hooks/useUserSettings';
import { PAGE_OPTIONS } from 'src/helpers/Constants';
import { TruncateText } from '../TruncateText';

interface Props {
  tasks: any[];
}

interface Tasks {
  type: string;
  status: string;
  startedDateTime: string;
  doneDateTime: string;
}

const initialSort: Array<ISortDescriptor> = [{ field: '', dir: 'asc' }];

export const TasksGrid: FC<Props> = ({ tasks }) => {
  const { getFormattedDateTime } = useUserSettings();
  const [sort, setSort] = useState(initialSort);
  const handleSortChange = (e: GridSortChangeEvent) => {
    setSort(e.sort as ISortDescriptor[]);
  };

  const renderStartedDate = ({ dataItem }: { dataItem: Tasks }) => {
    const date = getFormattedDateTime(dataItem.startedDateTime);
    return <td>
      <TruncateText text={date ?? ''} />
    </td>;
  };

  const renderDoneDate = ({ dataItem }: { dataItem: Tasks }) => {
    const date = getFormattedDateTime(dataItem.doneDateTime);
    return <td>
      <TruncateText text={date ?? ''} />
    </td>;
  };

  const extendedTasks = (tasks || []).map((task) => ({
    ...task,
    _startedDate: (renderStartedDate({ dataItem: task }) as any)?.props?.children,
    _doneDate: (renderDoneDate({ dataItem: task }) as any)?.props?.children,
  }));

  const metadata = [
    { field: 'type', title: 'Name', sortable: true },
    { field: 'status', title: 'Status', sortable: true },
    { field: 'startedDateTime', title: 'Start Date', type: 'component', object: '_startedDate', sortable: true },
    { field: 'doneDateTime', title: 'Done Date', type: 'component', object: '_doneDate', sortable: true },
  ];

  return (
    <Grid
      data={extendedTasks}
      metadata={metadata}
      scrollable="scrollable"
      sort={sort}
      pageOptions={PAGE_OPTIONS}
      onSortChange={handleSortChange}
    />
  );
};
